<template>
  <div class="col-span-6">
    <label for="field.label" class="block text-sm font-medium leading-5 text-gray-700">
      {{field.label}}
    </label>
    <select @change="$parent.updateValue(field.key, $event.target.value)" class="mt-1 mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
      <option v-if="options.length > 0" value="0"> {{ $t('message.dinamicform.selectfield.seleccioneopcion') }} </option>
      <template v-for="option in options">
        <option v-if="optionstype === 'dynamic'" v-bind:key="option[field.options_value]" v-bind:value="option[field.options_value]">{{option[field.options_label]}}</option>
        <option v-if="optionstype === 'fixed'" v-bind:key="option" v-bind:value="option">{{option}}</option>
      </template>
    </select>
  </div>
</template>
<script>
export default {
  name: 'select-field',
  data() {
    return {
      options: [],
      dependentdata: {},
      optionstype: 'dynamic'
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      required: false
    },
    formdata: {
      type: Object,
      required: true
    }
  },
  created() {
    this.checkDepends()
  },
  watch: {
    formdata: {
      deep: true,
      handler: async function(newVal) {
        console.log('formdata', newVal)
        if (this.field.depends !== '') {
          if (this.dependentdata[this.field.depends] !== newVal[this.field.depends]) {
            this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
            await this.fetchOptions()
          }
        }
      }
    },
    field: {
      deep: true,
      handler: function(newVal) {
        console.log('field', newVal)
        this.checkDepends()
      }
    },
  },
  methods: {
    checkDepends() {
      console.log('checkDepends', this.field)
      if (this.field.options.length > 0) {
        this.optionstype = 'fixed'
        this.options = this.field.options
      } else {
        if (this.field.depends === '') {
          this.fetchOptions()
        }
      }
    },
    async fetchOptions() {
      console.log('fetchOptions')
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'JWT ' + this.$store.getters.auth.token
        },
        params: {
          key: this.field.options_key,
          ...this.params,
          ...this.formdata,
          ...this.dependentdata
        }
      }
      const response = await this.$http.get(this.field.uri, config)
      this.options = response.data
    }
  }
}
</script>
